import { createPaths } from "@routes/utils";

import type { IExtractRouteParamMap } from "@routes";

const baseRoute = `/report-management/sales-report/item-based`;

export const itemBasedSalesReportRoutesObj = {
  list: baseRoute,
} as const;

export type IItemBasedSalesReportRouteParams = IExtractRouteParamMap<
  typeof itemBasedSalesReportRoutesObj
>;

export const itemBasedSalesReportPath = createPaths<
  typeof itemBasedSalesReportRoutesObj,
  IItemBasedSalesReportRouteParams
>(itemBasedSalesReportRoutesObj);
